import { Chip } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, subDays } from "date-fns";
import React, { useState, useEffect } from "react";

import { CustomChip } from "../../../CustomQueryChip";
import DateRange from "../../../DateRange";
import MultiSelectSearchV2 from "../../../MultiSelectSearchV2";

export default function CommLogFilters({
  setToDate,
  setFromDate,
  resetPagination,
  activeFilters,
  setActiveFiltersUsers,
  activeFiltersUsers,
  loggedInUser,
  selectedUsers,
  setSelectedUsers,
  resultCount,
  setSearchField,
}) {
  const [startDate, setStartDate] = useState(subDays(new Date(), 7));
  const [endDate, setEndDate] = useState(subDays(new Date(), 1));

  const setDateFrom = (value) => {
    setStartDate(value);
    setFromDate(value ? format(new Date(value), "yyyy-MM-dd") : null);
  };

  const setDateTo = (value) => {
    setEndDate(value);
    setToDate(value ? format(new Date(value), "yyyy-MM-dd") : null);
  };

  const displayFilters = (object) => {
    const returnArr = [];
    for (const [key, value] of Object.entries(object)) {
      if (key === "start_time__gte") {
        returnArr.push(`Date After: ${value}`);
      } else if (key === "start_time__lte") {
        returnArr.push(`Date Before: ${value}`);
      } else if (key === "sent_time__gte") {
        returnArr.push(`Date After: ${value}`);
      } else if (key === "sent_time__lte") {
        returnArr.push(`Date Before: ${value}`);
      } else {
        returnArr.push(`${key}: ${value}`);
      }
    }
    return returnArr;
  };

  const clearChipFilter = (filt) => {
    const key = filt.split(":")[0];
    if (key === "Date After") {
      setDateFrom(null);
    }
    if (key === "Date Before") {
      setDateTo(null);
    }
    if (key === "search") {
      setSearchField("");
    }
  };

  useEffect(() => {
    if (selectedUsers.length === 0) {
      setSelectedUsers([loggedInUser.pk]);
      setActiveFiltersUsers([loggedInUser.name]);
    } else if (selectedUsers.length > 1 && selectedUsers.includes(loggedInUser.pk)) {
      setSelectedUsers(selectedUsers.filter((item) => item !== loggedInUser.pk));
      setActiveFiltersUsers(activeFiltersUsers.filter((item) => item !== loggedInUser.name));
    }
  }, [setSelectedUsers, loggedInUser, setActiveFiltersUsers, activeFiltersUsers, selectedUsers]);

  return (
    <div
      id="CommLog-Filter-Container"
      data-testid="CommLog-Filter-Container"
      className="items-top relative flex"
    >
      <div className="absolute right-[31%] top-[10px] z-40 w-[25%] rounded-md bg-white px-4 py-3 shadow-md">
        <div>
          <MultiSelectSearchV2
            title="Filter by Managed User"
            searchTitle="User Search"
            selectedItems={selectedUsers}
            setSelectedItems={setSelectedUsers}
            setActiveItems={setActiveFiltersUsers}
            activeItems={activeFiltersUsers}
            resetPagination={resetPagination}
            nameKey={"name"}
            valueKey={"pk"}
            apiUrl={`/api/users/managed_users/?`}
          />
        </div>
      </div>
      <div className="absolute right-[5%] top-[10px] z-40 w-[25%] rounded-md bg-white">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateRange
            val={"Filter By Date"}
            dateFrom={startDate}
            dateTo={endDate}
            setDateFrom={setDateFrom}
            setDateTo={setDateTo}
            resetPagination={resetPagination}
          />
        </LocalizationProvider>
      </div>
      <div className="relative left-[10px] top-[70px] w-full">
        <CustomChip
          setActiveItems={setActiveFiltersUsers}
          activeItems={activeFiltersUsers}
          selectedItems={selectedUsers}
          setSelectedItems={setSelectedUsers}
          title="Users"
          resetPagination={resetPagination}
        />
        {activeFilters
          ? displayFilters(activeFilters).map((filt, idx) => {
              return (
                <Chip
                  className={`m-1 rounded-lg px-2 text-center shadow-inner`}
                  key={filt + idx}
                  onDelete={() => clearChipFilter(filt)}
                  label={filt}
                />
              );
            })
          : ""}
        <div className="w-full pr-16 text-right">
          Showing: {resultCount.current} / {resultCount.total}
        </div>
      </div>
    </div>
  );
}
